import { SERVICES } from "@/data/catalog";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useT } from "@/i18n/I18nProvider";

const ACCENTS = {
    terracotta: { bg: "bg-[#E07A5F]", text: "text-[#E07A5F]", soft: "bg-[#E07A5F]/8" },
    turquoise: { bg: "bg-[#3D8C95]", text: "text-[#3D8C95]", soft: "bg-[#3D8C95]/8" },
    magenta: { bg: "bg-[#C44569]", text: "text-[#C44569]", soft: "bg-[#C44569]/8" },
};

const TAG_KEYS = {
    "Populaire": "svc.tag.popular",
    "Accessible": "svc.tag.accessible",
    "Signature": "svc.tag.signature",
    "Premium": "svc.tag.premium",
    "Aromathérapie": "svc.tag.aromathérapie",
    "Rapide": "svc.tag.rapide",
    "Oriental": "svc.tag.oriental",
};

export default function ServicesSection() {
    const { t } = useT();
    return (
        <section
            id="services"
            data-testid="services-section"
            className="py-20 md:py-32 relative scroll-mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="max-w-3xl mb-16">
                    <div className="text-xs tracking-[0.3em] uppercase text-[#3D8C95] mb-4">
                        {t("services.eyebrow")}
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-[#2C2A29] tracking-tight leading-tight">
                        {t("services.title1")}{" "}
                        <span className="italic text-[#E07A5F]">{t("services.title2")}</span>
                        {t("services.title3")}
                    </h2>
                    <p className="mt-5 text-[#6E6862] leading-relaxed text-base md:text-lg">
                        {t("services.desc")}
                    </p>
                    <p className="mt-4 inline-flex items-center gap-2 text-sm text-[#3D8C95] italic font-medium">
                        ✓ Reçu d&apos;assurance fourni pour tous les soins · disponibles en clinique ou à domicile
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {SERVICES.map((s, i) => {
                        const a = ACCENTS[s.accent];
                        const tagKey = s.tag ? TAG_KEYS[s.tag] : null;
                        return (
                            <Card
                                key={s.id}
                                data-testid={`service-card-${s.id}`}
                                className={`relative rounded-3xl bg-white border border-[#E8E2D9] p-7 md:p-8 shadow-[0_8px_30px_rgba(44,42,41,0.04)] hover:shadow-[0_20px_60px_rgba(44,42,41,0.08)] transition-all duration-500 hover:-translate-y-1 ${
                                    i === 0 ? "md:col-span-2 lg:col-span-1" : ""
                                }`}
                            >
                                {tagKey && (
                                    <Badge
                                        data-testid={`service-tag-${s.id}`}
                                        className={`absolute top-6 right-6 ${a.bg} text-white rounded-full px-3 py-1 text-[10px] uppercase tracking-widest font-medium border-0`}
                                    >
                                        {t(tagKey)}
                                    </Badge>
                                )}
                                <div className={`w-12 h-12 rounded-2xl ${a.soft} flex items-center justify-center mb-5`}>
                                    <div className={`w-3 h-3 rounded-full ${a.bg}`} />
                                </div>
                                <h3 className="font-display text-2xl md:text-3xl text-[#2C2A29] tracking-tight mb-1">
                                    {t(`svc.${s.id}.name`)}
                                </h3>
                                <div className={`text-sm ${a.text} italic mb-4`}>
                                    {t(`svc.${s.id}.sub`)}
                                </div>
                                <p className="text-sm text-[#6E6862] leading-relaxed mb-6 min-h-[60px]">
                                    {t(`svc.${s.id}.desc`)}
                                </p>
                                <div className="space-y-2 pt-5 border-t border-[#E8E2D9]">
                                    {s.variants.map((v) => (
                                        <div
                                            key={v.id}
                                            data-testid={`variant-${v.id}`}
                                            className="flex items-center justify-between"
                                        >
                                            <span className="text-sm text-[#2C2A29]">
                                                {v.label}
                                            </span>
                                            <span className="font-display text-xl text-[#2C2A29]">
                                                {v.price}<span className="text-sm text-[#6E6862]"> $</span>
                                            </span>
                                        </div>
                                    ))}
                                </div>
                                {s.id === "releve" && (
                                    <p className="mt-4 text-[11px] italic text-[#C44569]">
                                        {t("services.student_note")}
                                    </p>
                                )}
                            </Card>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
